import React from 'react';
import { Spinner } from 'react-bootstrap';

/** Zone de chargement centrée. */
export default function ReceptionLoadingBlock({ label = 'Chargement…', size = 'md' }) {
  const spinnerSize = size === 'sm' ? 'sm' : undefined;
  return (
    <div className={`recv-loading-block recv-loading-block--${size}`} role="status" aria-live="polite">
      <Spinner animation="border" variant="primary" size={spinnerSize} />
      <span className="recv-loading-block__label">{label}</span>
    </div>
  );
}
